import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as courseModule from './courseModule.module.scss';

export const CourseModuleThree = ({ badgeText, resultText }) => {
  return (
    <section className={`${courseModule.courseModule} ${courseModule.courseModuleThree}`}>
      <div className="container">
        <p className={courseModule.courseModule__important}>{badgeText} 3</p>
        <h3 className={courseModule.courseModule__subtitle}>Эффективное чтение</h3>
        <p className={courseModule.courseModule__description}>
          Ребенок освоит техники позволяющие быстрее читать и&nbsp;лучше запоминать и&nbsp;понимать прочитанный текст.
          Акцент делается именно на&nbsp;понимании материала.
        </p>
        <div className={`row ${courseModule.courseModule__row}`}>
          <div className="col-12 col-lg-9">
            <p className={courseModule.courseModule__listTitle}>Формируемые навыки:</p>
            <ul className={courseModule.courseModule__list}>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Осваиваем 7&nbsp;методик скорочтения</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Ставить цели при работе с&nbsp;текстом</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Выбирать оптимальную методику в&nbsp;зависимости от цели и&nbsp;от&nbsp;текста
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Увеличиваем скорость чтения от&nbsp;2&nbsp;до&nbsp;4&nbsp;раз
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Ускоряем вокализацию&nbsp;– скорость проговаривания текста (положительно сказывается на&nbsp;дикции
                  и&nbsp;развитии речевых навыков)
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Функциональная грамотность</p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>
                  Быстро находить нужное в&nbsp;сложном информационном массиве
                </p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>
                  Встраивать новую информацию в&nbsp;общую картину на&nbsp;большой скорости
                </p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>Ещё большая интеллектуальная выносливость</p>
              </li>
            </ul>
          </div>
          <div className={`col-12 col-lg-3 ${courseModule.courseModule__sideData}`}>
            <div className={main.sideData}>
              <p className={main.sideData__smallText}>
                <b>
                  Мы <span className={main.sideData__smallTextUppercase}>не</span> используем методики подавления
                  проговаривания
                </b>
              </p>
            </div>
            <div className={main.sideData}>
              <p className={main.sideData__smallText}>Больше половины детей выходят на&nbsp;скорость чтения более</p>
              <p className={`${main.sideData__bigText} ${main.sideData__bigTextIndent}`}>500 слов</p>
              <p className={main.sideData__smallText}>в минуту с&nbsp;полным пониманием прочитанного материала</p>
            </div>
          </div>
        </div>

        <div className={courseModule.courseModule__result}>
          <h3 className={courseModule.courseModule__resultTitle}>{resultText}</h3>
          <div className="row">
            <div className={`col-12 col-md-6 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>Ребенок начинает Читать с&nbsp;большой буквы</p>
            </div>
            <div className={`col-12 col-md-6 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Выход на&nbsp;скорость «книга за&nbsp;вечер» делает груду книг из&nbsp;испорченного домашкой лета всего
                лишь недельной задачей, что резко снижает масштаб и&nbsp;сложность всех остальных жизненных задач
              </p>
            </div>
            <div className={`col-12 col-md-6 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Любовь к&nbsp;чтению становится надежной опорой для любви к&nbsp;учебе и&nbsp;развитию
                на&nbsp;протяжении всей жизни
              </p>
            </div>
            <div className={`col-12 col-md-6 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Люди, читающие книги, всегда будут управлять теми, кто смотрит телевизор
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
